import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { v4 as uuidv4 } from 'uuid';

/**
 * Store dla zarządzania podkładem w projekcie
 */
const useBackgroundStore = create(
  persist(
    (set, get) => ({
      // Stan podkładu
      backgroundItem: null, // { id, imageUrl, x, y, scale, opacity, width, height }
      selectedBackgroundId: null,
      isDraggingBackground: false,
      dragStartPos: null,

      // Akcje
      addBackgroundItem: (imageUrl, position = { x: 400, y: 300 }) => {
        // Load image to get dimensions
        const img = new Image();
        img.onload = () => {
          const backgroundId = uuidv4();
          const newBackgroundItem = {
            id: backgroundId,
            imageUrl: imageUrl,
            x: position.x,
            y: position.y,
            scale: 1.0,
            opacity: 0.3, // Domyślnie niższa przezroczystość dla podkładu
            width: img.width,
            height: img.height,
            originalWidth: img.width,
            originalHeight: img.height
          };
          set({ backgroundItem: newBackgroundItem, selectedBackgroundId: backgroundId });
        };
        img.src = imageUrl;
        return uuidv4();
      },
      removeBackgroundItem: () => {
        set({ backgroundItem: null, selectedBackgroundId: null });
      },
      updateBackgroundItem: (updates) => {
        set((state) => ({
          backgroundItem: state.backgroundItem ? { ...state.backgroundItem, ...updates } : null
        }));
      },
      selectBackgroundItem: (backgroundId) => {
        set({ selectedBackgroundId: backgroundId });
      },
      clearBackgroundSelection: () => {
        set({ selectedBackgroundId: null });
      },

      // Dragging
      startDraggingBackground: (startPos) => {
        const { selectedBackgroundId } = get();
        set({ isDraggingBackground: true, selectedBackgroundId: selectedBackgroundId || get().backgroundItem?.id, dragStartPos: startPos });
      },
      updateDraggingBackground: (newPos) => {
        const { isDraggingBackground, backgroundItem } = get();
        if (!isDraggingBackground || !backgroundItem) return;

        get().updateBackgroundItem({ x: newPos.x, y: newPos.y });
      },
      stopDraggingBackground: () => {
        set({ isDraggingBackground: false, dragStartPos: null });
      },

      // Scale with aspect ratio
      scaleBackgroundItem: (scaleFactor) => {
        const item = get().backgroundItem;
        if (!item) return;
        const newScale = Math.max(0.1, Math.min(5.0, item.scale * scaleFactor));
        get().updateBackgroundItem({ scale: newScale });
      },

      // Clear background
      clearBackground: () => {
        set({ backgroundItem: null, selectedBackgroundId: null, isDraggingBackground: false, dragStartPos: null });
      }
    }),
    {
      name: 'floorcraft-background-storage',
      version: 2,
      migrate: () => ({}),
      partialize: () => ({}),
    }
  )
);

export default useBackgroundStore;